import { createFileRoute } from "@tanstack/react-router";
import { articlesByLang } from "@/lib/articles-meta";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { LinkRows, PageIntro, PageSection } from "@/components/site/page";

export const Route = createFileRoute("/dergi/")({
  head: () => ({
    meta: [
      { title: "Dergi Yazıları — Arda Öztaşkın" },
      {
        name: "description",
        content:
          "Centre, The Brand Map ve The Newsight dergilerinde yayımlanan yazıların arşivi.",
      },
      { property: "og:title", content: "Dergi Yazıları — Arda Öztaşkın" },
      { property: "og:description", content: "Centre, The Brand Map ve The Newsight dergilerinde yayımlanan yazıların arşivi." },
      { property: "og:url", content: "https://akillisurdurulebilirlik.com/dergi" },
      { property: "og:locale", content: "tr_TR" },
      { property: "og:locale:alternate", content: "en_US" },
    ],
    links: [
      { rel: "canonical", href: "https://akillisurdurulebilirlik.com/dergi" },
      ...hreflangLinks("/dergi"),
    ],
  }),
  component: ArchivePage,
});

function ArchivePage() {
  const { lang } = useT();
  const list = articlesByLang(lang);

  return (
    <>
      <PageIntro
        crumbs={[{ label: "Dergi" }]}
        kicker="Centre · The Brand Map · The Newsight"
        title={lang === "tr" ? "Dergi Yazıları" : "Magazine Writing"}
      />
      <PageSection>
        <LinkRows
          items={list.map((a) => ({
            key: a.slug,
            to: "/dergi/$slug" as const,
            params: { slug: a.slug },
            kicker: <span className="text-[10px] uppercase tracking-[0.2em] text-ink/70">{a.magazine} · {a.date}</span>,
            title: a.title,
            excerpt: a.excerpt,
          }))}
        />
      </PageSection>
    </>
  );
}
